<template>
  <div>
    <div class="document">
      <!-- <img src="../../../assets/img/logo/NAN_logomark_RGB_Evergreen.png" alt="" class="center" style="width: 110px; padding-bottom: 10px;"> -->
      <h3 style="text-align: center;">CLIENT- AGENCY AGREEMENT PLACEMENT FEE & REFUND POLICY</h3>
      <hr>
      <div style="margin-top: -10px;" v-if="document.status == 'Unsigned'">
        <label style="margin-top: 10px;">Client Name</label>
        <input type="text" class="form-control" v-model="field1">
        <label style="margin-top: 10px;">Address</label>
        <input type="text" class="form-control" v-model="field2">
        <label style="margin-top: 10px;">Email</label>
        <input type="text" class="form-control" v-model="field3">
      </div>
      <div v-if="document.status == 'Signed'">
        <p>Client Name: {{ document.field1 }}</p>
        <p>Address: {{ document.field2 }}</p>
        <p>Email: {{ document.field3 }}</p>
      </div>
      <pre class="mt-3" v-html="document.body"></pre>
      <hr>
      <p style="font-weight: 600; margin-bottom: 0;">Client</p>
      <p v-if="document.status == 'Unsigned'">{{ new Date().toDateString() }}</p>
      <p v-if="document.status == 'Signed'">{{ new Date(document.signing_date).toDateString() }}</p>
      <h4 v-if="signature" style="font-family: 'Arizonia'; text-transform: none;">{{ signature }}</h4>
      <h4 v-if="!signature">___________</h4>
      <p v-if="document.status == 'Signed'">{{ document.signing_name }}</p>
      <div v-if="!document.signing_name">
        <input type="text" class="form-control" v-model="signature" style="max-width: 500px;">
        <label class="mt-1">Signature of the Client (Please Type)</label>
        <div>
          <button v-if="!signature || !field1 || !field2 || !field3" class="mylisting-button disabled-button mt-3" style="cursor: not-allowed; color: gray;" @click.prevent="">Sign</button>
          <button v-else class="mylisting-button dark-button mt-3" @click="sign()">Sign</button>
          <!-- <button v-if="signature" class="mylisting-button dark-button mt-3" @click="sign()">Sign</button> -->
        </div>
      </div>

      <p style="font-weight: 600; margin-top: 25px;">Coast to Coast Nannies Agency</p>
      <!-- <p>{{ new Date(document.signing_date_secondary).toDateString() }}</p> -->
      <h4 v-if="document.signing_name_secondary" style="font-family: 'Arizonia'; text-transform: none;">{{ document.signing_name_secondary }}</h4>
      <p>Per: {{ document.signing_name_secondary }}</p>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  props: ['document'],
  data() {
    return {
      field1: '',
      field2: '',
      field3: '',
      signature: '',
    }
  },
  created() {
    this.field1 = this.document.field1
    this.field2 = this.document.field2
    this.field3 = this.document.field3
    this.signature = this.document.signing_name
  },
  methods: {
    sign() {
      axios.patch(`/api/documents/${this.document.id}/`, {
        field1: this.field1,
        field2: this.field2,
        field3: this.field3,
        signing_name: this.signature,
        signing_date: this.todayDatetimeDjangoFormat,
        status: 'Signed',
      })
        .then(res => {
          console.log(res)
          this.$emit('documentSigned')
        })
        .catch(error => {
          console.log(error)
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/employers/documents/FamilyAgencyContract.vue